class CollapsibleFooter extends Collapsible {
  constructor() {
    super();
    if (!this.options.breakpoint) {
      this.options.breakpoint = parseInt(768);
    }
    this.windowWidth = window.innerWidth;
    this.displayDetails();
  }

  construct() {
    super.construct();

    window.addEventListener('resize', () => {
      if (this.windowWidth == window.innerWidth) {
        return;
      }
      this.windowWidth = window.innerWidth;
      this.displayDetails();
    });
  }

  open(group) {
    if (window.innerWidth < this.options.breakpoint) {
      super.open(group);
    }
  }

  close(group) {
    if (window.innerWidth < this.options.breakpoint) {
      super.close(group);
    }
  }

  displayDetails() {
    if (window.innerWidth >= this.options.breakpoint) {
      this.openAll();
    } else {
      this.closeAll();
    }
  }
}

if (!customElements.get('collapsible-footer')) {
  customElements.define('collapsible-footer', CollapsibleFooter);
}

if (!customElements.get('spotler-footer')) {
  class SpotlerFooter extends HTMLElement {
    constructor() {
      super();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((section) => {
            if (section.isIntersecting) {
              const spotlerLoader = this.querySelector('load-spotler-scripts');
              if (spotlerLoader) {
                spotlerLoader.loadScriptsAndStyles();
                observer.unobserve(section.target);
              }
            }
          });
        });
        this.observer.observe(this);
      }
    }
  }

  window.SpotlerFooter = SpotlerFooter;

  customElements.define('spotler-footer', SpotlerFooter);
}
